/**
 * Awards store their color either as a Vuetify theme name
 * (e.g. "primary", "warning") or as a literal hex value
 * (e.g. "#FFD700"). The overlay needs an actual CSS color for its
 * radial backdrop, so this resolves theme names to the same hex
 * tokens defined in plugins/vuetify.ts.
 *
 * Keep in sync with the lockinLight palette there.
 */
const THEME_TO_HEX: Record<string, string> = {
  primary:    '#1FA8F2',
  secondary:  '#3BC4B5',
  accent:     '#3BC4B5',
  error:      '#EF4444',
  info:       '#1FA8F2',
  success:    '#10B981',
  warning:    '#F59E0B',
  indigo:     '#4F46E5',
  grey:       '#6B7280',
};

export function resolveAwardColor(c: string): string {
  if (!c) return '#1FA8F2';
  if (c.startsWith('#')) return c;
  return THEME_TO_HEX[c.toLowerCase()] ?? '#1FA8F2';
}
